import React, { Fragment, useEffect, useRef } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
const useStyles = makeStyles((theme) => ({
  videoContainer: {
    overflow: "hidden",
    paddingBottom: "56.25%",
    position: "relative",
    height: 0,
  },
  video: {
    left: 0,
    top: 0,
    height: "100%",
    width: "100%",
    position: "absolute",
  },
}));

function Eyepiece2Resource() {
  const classes = useStyles();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={7}>
        <Typography variant="h5" gutterBottom>
          Direct Resources for support Sessions 1-3 activities
        </Typography>
        <Typography variant="body1" gutterBottom>
          The resources below provide teachers the information and materials
          needed to help collect, code, and reflect on their student classroom
          drawings. Two videos explain the processes of collecting and coding
          drawings, while coding rubrics, blank drawing forms and instructional
          sheets are provided as .pdf documents:
        </Typography>
        <ul>
          <li>
            <Link
              href="https://youtu.be/nKQ9_HXGvSA"
              variant="subtitle1"
              target="_blank"
            >
              Video of Dr. Bebell explaining Collecting Student Drawings
            </Link>
          </li>
          <li>
            <Link
              href="https://youtu.be/Rik6_di6ovY"
              variant="subtitle1"
              target="_blank"
            >
              Video of Dr. Bebell explaining Coding Student Drawings
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/Drawing on Math Coding Rubric Operational Defintions.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              Operational definition of drawing codes
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/DrawingPrompt_Form.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              Blank drawing form for local printing
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/BMR eyepiece 2- A guide to coding student drawings.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              Teacher instruction sheet for collecting drawing
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/BMR eyepiece 2- A guide to coding student drawings.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              Instruction sheet for coding/inputting drawings
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/drawing on math coding rubric.xlsx"
              }
              variant="subtitle1"
              target="_blank"
            >
              Spreadsheet for drawing data
            </Link>
          </li>
        </ul>

        <Typography variant="h6" gutterBottom>
          Background/Supporting Resources for Drawings as a Reflection and
          Research Tool
        </Typography>
        <Typography variant="body1" gutterBottom>
          The following academic resources summarize the long and rich
          background for using student drawings as a research and reflection
          tool.
        </Typography>

        <ul>
          <li>
            <Link
              href="https://books.apple.com/us/book/research-for-educators/id1088992950"
              variant="subtitle1"
              target="_blank"
            >
              Research for Educators book
            </Link>
          </li>

          <li>
            <Link
              href={process.env.PUBLIC_URL + "/assets/Eyepiece2/Hatisaru.pdf"}
              variant="subtitle1"
              target="_blank"
            >
              Draw a Mathematics Classroom! Teaching and Learning Practices
              through the Eyes of Students
            </Link>
          </li>
          <li>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/What Can Student Drawings Tell Us About High Stakes Testing in MA.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              TCRecord Research Paper
            </Link>
          </li>
          <li>
            <Typography variant="body2">
              Other ideas for capturing and using data with your school and
              classroom can be found in Apple’s free, research for Educators
              book:
            </Typography>
            <Link
              href={
                process.env.PUBLIC_URL +
                "/assets/Eyepiece2/Drawing On Education Harvard Educational Review.pdf"
              }
              variant="subtitle1"
              target="_blank"
            >
              Harvard Ed Review Research Paper
            </Link>
          </li>
        </ul>
      </Grid>
      <Grid item s={12} md={5}>
        <Box className={classes.videoContainer}>
          <iframe
            className={classes.video}
            src="https://www.youtube.com/embed/WCSB-ghjVgA"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Box>
      </Grid>
    </Grid>
  );
}

export default Eyepiece2Resource;
